import { render, staticRenderFns } from "./AccountCheck.vue?vue&type=template&id=1f59c96c&scoped=true"
import script from "./AccountCheck.vue?vue&type=script&lang=js"
export * from "./AccountCheck.vue?vue&type=script&lang=js"
import style0 from "./AccountCheck.vue?vue&type=style&index=0&id=1f59c96c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f59c96c",
  null
  
)

export default component.exports